import { getCurrentUser } from "@/api/authentication";
import { LoaderFunctionArgs, defer, json, redirect } from "react-router-dom";

export interface IOnboardingLoaderData {}

export async function OnboardingLoader({ request }: LoaderFunctionArgs) {
  const session = await getCurrentUser(request.signal);
  if (!session) throw redirect("/auth");
  return {} as IOnboardingLoaderData;
}
